import { http, HttpResponse } from 'msw'

import {
    allMachineRelations,
    allMachineRelationsShort,
} from 'app/mocks/data/machines/machineRelations'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import {
    MachineRelation,
    MachineRelationShort,
    MachineRelationsRequest,
} from 'app/types/park/machineRelation'

export const getAllMachineRelations = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.relations.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const sitesIdsFilter = searchParams.get('sub_machines__site__in')
        const terminalsIdsFilter = searchParams.get('machine__id__in')
        const shortFilter = searchParams.get('get_sub_machines')

        let allMachineRelationsFiltered:
            | MachineRelation[]
            | MachineRelationShort[] =
            shortFilter === 'true'
                ? allMachineRelationsShort
                : allMachineRelations

        // Sites filter
        if (sitesIdsFilter) {
            const sitesIdsSplit = queryIntoArrayNumber(sitesIdsFilter)

            // If site IDs, we filter the machines
            allMachineRelationsFiltered = allMachineRelationsFiltered.filter(
                (machineRelation) => {
                    return sitesIdsSplit.includes(
                        machineRelation.machine.site.id,
                    )
                },
            )
        }

        // Machines filter
        if (terminalsIdsFilter) {
            const terminalsIdsSplit = queryIntoArrayNumber(terminalsIdsFilter)

            allMachineRelationsFiltered = allMachineRelationsFiltered.filter(
                (machineRelation) =>
                    terminalsIdsSplit.includes(machineRelation.machine.id),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allMachineRelationsFiltered.length > limit
                ? offset + limit
                : allMachineRelationsFiltered.length

        const results = allMachineRelationsFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allMachineRelationsFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<MachineRelationsRequest>({
            next,
            results,
        })
    },
)
